/**
 * PreviewStickyCta — Sticky bottom CTA bar
 */

interface PreviewStickyCtaProps {
  data: {
    text?: string;
    note?: string;
    buttonText?: string;
    phone?: string;
  };
}

export function PreviewStickyCta({ data }: PreviewStickyCtaProps) {
  return (
    <div className="preview-sticky">
      <div className="preview-sticky__inner">
        <div className="preview-sticky__text">
          <div style={{ fontWeight: 650 }}>{data.text}</div>
          {data.note ? (
            <div style={{ opacity: 0.8, fontSize: "0.95em" }}>
              {data.note}
            </div>
          ) : null}
        </div>
        <div className="preview-sticky__actions">
          <a href="#kontakt" className="preview-btn preview-btn--primary">
            {data.buttonText || "Termin"}
          </a>
          {data.phone ? (
            <a href={`tel:${data.phone}`} className="preview-btn">
              {data.phone}
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}
